import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

const ACTION_PREFIX = "[Phone Verification]";
export const PHONE_VERIFICATION_ACTION_TYPE = {
	requestCode: `${ACTION_PREFIX} Request Code`,
	requestCodeSuccess: `${ACTION_PREFIX} Request Code Success`,
	requestCodeFail: `${ACTION_PREFIX} Request Code Fail`,

	verifyCode: `${ACTION_PREFIX} Verify Code`,
	verifyCodeSuccess: `${ACTION_PREFIX} Verify Code Success`,
	verifyCodeFail: `${ACTION_PREFIX} Verify Code Fail`,
};

/**
 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
 */
@Injectable({
	providedIn: "root",
})
export class PhoneVerificationAction {
	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	requestCode(phoneNumber: string): ActionWithPayload {
		return {
			type: PHONE_VERIFICATION_ACTION_TYPE.requestCode,
			payload: phoneNumber,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	requestCodeSuccess(): Action {
		return {
			type: PHONE_VERIFICATION_ACTION_TYPE.requestCodeSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	requestCodeFail(error: AppError): ActionWithPayload {
		return {
			type: PHONE_VERIFICATION_ACTION_TYPE.requestCodeFail,
			payload: error,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	verifyCode(smsCode: number): ActionWithPayload {
		return {
			type: PHONE_VERIFICATION_ACTION_TYPE.verifyCode,
			payload: smsCode,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	verifyCodeSuccess(): Action {
		return {
			type: PHONE_VERIFICATION_ACTION_TYPE.verifyCodeSuccess,
		};
	}

	/**
	 * @deprecated [fabric-deprecated] - use fabric PhoneVerificationService from app-account instead
	 */
	verifyCodeFail(error: AppError): ActionWithPayload {
		return {
			type: PHONE_VERIFICATION_ACTION_TYPE.verifyCodeFail,
			payload: error,
		};
	}
}
